import { useState } from "react";

import { Button } from "./ui/button";
import { type IPlaybookClause } from "../hooks/playbook-clause";

interface ICellProps {
	clause: IPlaybookClause;
}

function ClauseCell({ clause }: ICellProps) {
	const [showMore, setShowMore] = useState<boolean>(false);

	return (
		<div className="text-xs border rounded-md px-2 py-1.5 gap-1 flex flex-col">
			<p className="font-semibold">{clause.key.trim().replace(/[^a-zA-Z0-9&().,\\\-_:;!?'"/\s]/g, "")}</p>
			<p>
				{showMore
					? clause.standard_answer.replace(/[^a-zA-Z0-9&().,\\\-_:;!?'"/\s]/g, "")
					: clause.standard_answer.substring(0, 75).replace(/[^a-zA-Z0-9&().,\\\-_:;!?'"/\s]/g, "")}
				<Button
					variant="link"
					onClick={() => {
						setShowMore((prev) => !prev);
					}}
					className="text-xs text-primary !p-0.5 decoration-dashed !h-auto"
				>
					{showMore ? "show less" : "read more..."}
				</Button>
			</p>
		</div>
	);
}

export { ClauseCell };
